import {CellsContext} from '../../../../src/store/panels/cells/context/cellsContext';

export function shouldShowInboxZero(cellsContext: CellsContext) {
  const {
    inDrafts,
    inSent,
    isDelegation,
    isAssignedShared,
    inOpenFilter,
    searchQuery,
    isCellsEmptySetupActionsActive,
  } = cellsContext;

  return (
    inOpenFilter &&
    !inDrafts &&
    !inSent &&
    !isDelegation &&
    !isAssignedShared &&
    !searchQuery &&
    !isCellsEmptySetupActionsActive
  );
}
